export default __webpack_public_path__ + "static/NGSwv5HMAFg6IuGlBNMjxLsJ8ahuQ2e8Smg-35ba98cddaa91679f3d511e07575312b.woff2";